import i18n from '@/locales/index';
import groupButtons from './pages/groups/list/components/groupButtons';
import contactButtons from './pages/contacts/list/components/contactButtons';

export const contactsRoutes = {
	path: 'contacts',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: '',
            name: 'contacts-list',
			component: () => import('./pages/contacts/list/index.vue'),
			meta: {
				title: i18n.global.t('contacts.contacts'),
                headerExtraComponent: contactButtons,
			},
		},
        //begin::groups
		{
			path: 'groups',
            name: 'contacts-group',
			component: () => import('./pages/groups/list/index.vue'),
			meta: {
				title: i18n.global.t('contacts.manage-groups'),
                headerExtraComponent: groupButtons,
			},
		},
        {
            path: 'groups/create',
            name:'contacts-create-groups',
            component: () => import('./pages/groups/create-edit/index.vue'),
            props: true,
            meta: {
                title: i18n.global.t(`contacts.create-new-group`),
            },
        },
        {
            path: 'groups/edit/:id',
            name:'contacts-edit-groups',
            component: () => import('./pages/groups/create-edit/index.vue'),
            props: true,
            meta: {
                title: i18n.global.t(`contacts.edit-group`),
            },
        }
        //end::groups
	],
};
